import { render, staticRenderFns } from "./TransactionHistoryOther.vue?vue&type=template&id=e67ffdb6&"
import script from "./TransactionHistoryOther.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports